import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

// --- Global styles (must load at the app root) -----------------------------
// This app's component/page CSS is written as GLOBAL styles: many files define
// classes that other pages use without importing them (e.g. AdminDashboard uses
// .clubCard / .club_image_card / .card_div, which live in PlayersCard.css).
// That worked only because App.js eagerly imported every page, so every CSS file
// landed in the main bundle. Route-level code-splitting (React.lazy in App.js)
// broke that contract — a CSS file now ships only in its own lazy chunk, so any
// class defined in a component that a given route doesn't render is simply
// absent, leaving that route unstyled.
//
// The CSS totals ~155 KB, so we keep the JS code-splitting win but load ALL
// styles up front, exactly as before. Library styles come first so the app's
// own CSS can override them.
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
// Base/reset styles next, in a controlled position, before the app's component
// and page CSS is pulled in by the glob below.
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { Provider } from "react-redux";
import store from "redux/store";
import { BrowserRouter, useLocation } from "react-router-dom";

// Eagerly import every CSS file under src so global classes are always present,
// regardless of which lazily-loaded route is rendered (see note above).
const cssModules = require.context("./", true, /\.css$/);
cssModules.keys().forEach(cssModules);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
axios.defaults.baseURL = process.env.REACT_APP_USER_BASE_URL;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
